import qs from 'qs';
/**
 * Creates a query string from an object.
 *
 * @example
 * import { Url } from '@catawiki/runtime-toolkit';
 *
 * const searchObject: Url.SearchParams = {
 * name: 'John',
 * age: 30,
 * };
 *
 * expect(Url.createSearch(searchObject)).toBe('name=John&age=30');
 */
export const createSearch = (searchObject, options = {}) => qs.stringify(searchObject, { arrayFormat: 'brackets', ...options });
/**
 * Parses a query string into an object.
 *
 * @example
 * import { Url } from '@catawiki/runtime-toolkit';
 *
 * const queryString = 'name=John&age=30';
 * const searchObject = Url.parseSearch(queryString);
 *
 * expect(searchObject).toEqual({ name: 'John', age: '30' });
 */
export const parseSearch = (searchString, options = {}) => qs.parse(searchString, {
    ignoreQueryPrefix: true,
    ...options,
});
